import CLC2UniMenteePage from "./CLC2UniMenteePage";

export default CLC2UniMenteePage;
